import clsx from 'clsx';
import React from 'react';
import PropTypes from 'prop-types';

const Field = ({
  label, description, required, children, showError, dirty, id
}) => {
  return (
    <div
      className={clsx('p2p-field__container', showError && !dirty && 'p2p-field__container--error')}
      id={id}
    >
      <div className="p2p-field__head-container">
        {label && (
          <div className="p2p-field__label">
            <span>{label}</span>
            {required && <span className="p2p-field__label--required"> *</span>}
          </div>
        )}
        {description && (
          <div className="p2p-field__description">
            <span>{description}</span>
          </div>
        )}
      </div>
      {children}
    </div>
  );
};

Field.propTypes = {
  label: PropTypes.string.isRequired,
  description: PropTypes.string,
  required: PropTypes.bool,
  showError: PropTypes.bool,
  dirty: PropTypes.bool
};

Field.defaultProps = {
  description: '',
  required: false,
  showError: false,
  dirty: false
};

export default Field;
